"use strict";

require("../../style/default.css");
require("./index.css");